import { takeEvery, fork, put, all, call, takeLatest, select } from "redux-saga/effects";

// Login Redux States
import { SettingsActionTypes } from "./types";
import {
  settingsApiResponseSuccess,
  settingsApiResponseError,
  setAppUpdateInfo,
} from "./actions";

import {
  getSettings as getSettingsApi,
  updateSettings as updateSettingsApi,
  loadThirdApiUrl as loadThirdApiUrlApi,
  ucLoadUserConfig as ucLoadUserConfigApi,
  performAppUpdateCheck as performAppUpdateCheckApi,
} from "../../api/index";
import { ThirdApi } from "api/apiThird";
import { Utils } from "helpers/utils";

function* getSettings() {
  try {
    const response: Promise<any> = yield call(getSettingsApi);
    yield put(
      settingsApiResponseSuccess(
        SettingsActionTypes.GET_USER_SETTINGS,
        response
      )
    );
  } catch (error: any) {
    yield put(
      settingsApiResponseError(SettingsActionTypes.GET_USER_SETTINGS, error)
    );
  }
}

function* ucLoadUserConfig() {
  try {
    const response: Promise<any> = yield call(ucLoadUserConfigApi);
    // console.log('ucLoadUserConfig:', response);
    yield put(settingsApiResponseSuccess(SettingsActionTypes.UC_LOAD_USER_CONFIG,response));
  } catch (error: any) {
    yield put(settingsApiResponseError(SettingsActionTypes.UC_LOAD_USER_CONFIG, error));
  }
}

function* loadThirdApiUrl() {
  try {
    const response: Promise<any> = yield call(loadThirdApiUrlApi);
    ThirdApi.setApiUrl(response);
    // yield put(settingsApiResponseSuccess(SettingsActionTypes.GET_USER_SETTINGS,response));
  } catch (error: any) {
    // yield put(settingsApiResponseError(SettingsActionTypes.GET_USER_SETTINGS, error));
  }
}


function* checkAppUpdate() {
  try {
    const userType: Promise<any> = yield select((state: any) => state.Profile2.userType);
    const result: Promise<any> = yield call(performAppUpdateCheckApi, userType as any);
    yield put(setAppUpdateInfo(result as any));
    // automatic (boot/resume) check stays silent for optional updates - only a badge, no popup.
    // a critical update still forces the blocking dialog even when this check ran silently.
    if ((result as any)?.forceupdate) {
      Utils.ShowAppUpdateResult(result as any);
    }
  } catch (error: any) {
    // silent - keep whatever result the last successful check stored, retry again on next check
  }
}


function* updateSettings({ payload: { field, value } }: any) {
  try {
    const response: Promise<any> = yield call(updateSettingsApi, field, value);
    yield put(
      settingsApiResponseSuccess(
        SettingsActionTypes.UPDATE_USER_SETTINGS,
        response
      )
    );
  } catch (error: any) {
    yield put(
      settingsApiResponseError(SettingsActionTypes.UPDATE_USER_SETTINGS, error)
    );
  }
}

export function* watchGetSettings() {
  yield takeEvery(SettingsActionTypes.GET_USER_SETTINGS, getSettings);
}
export function* watchUcLoadUserConfig() {
  yield takeEvery(SettingsActionTypes.UC_LOAD_USER_CONFIG, ucLoadUserConfig);
}
export function* watchUpdateSettings() {
  yield takeEvery(SettingsActionTypes.UPDATE_USER_SETTINGS, updateSettings);
}

export function* watchLoadThirdApiUrl() {
  yield takeLatest(SettingsActionTypes.LOAD_THIRD_API_URL, loadThirdApiUrl);
}

export function* watchCheckAppUpdate() {
  yield takeLatest(SettingsActionTypes.CHECK_APP_UPDATE, checkAppUpdate);
}


function* settingsSaga() {
  yield all([
    fork(watchGetSettings),
    fork(watchUcLoadUserConfig),
    fork(watchUpdateSettings),
    fork(watchLoadThirdApiUrl),
    fork(watchCheckAppUpdate)
  ]);
}

export default settingsSaga;
